import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: block;
  width: 100%;
  word-wrap: break-word;

  &.markdown-content {
    font-size: ${(props) => props.theme.fontSize?.base || props.theme.fonts?.size?.b1 || '14px'};
    line-height: 1.5;
    color: inherit;

    .highlight-current,
    .highlight-other,
    mark.highlight-current,
    mark.highlight-other {
      display: inline;
      padding: 0;
      margin: 0;
      color: inherit;
      font: inherit;
    }
    .highlight-current,
    mark.highlight-current {
      background-color: #ED6C0266;
    }
    .highlight-other,
    mark.highlight-other {
      background-color: #2173FF66;
    }

    p {
      margin: 0 0 0.75em;
      &:last-child {
        margin-bottom: 0;
      }
    }
    ul, ol {
      margin: 0.5em 0;
      padding-left: 1.5em;
    }
    code {
      background: ${(props) => props.theme.colors?.greySix || 'rgba(0,0,0,0.06)'};
      padding: 0.2em 0.4em;
      border-radius: 4px;
      font-size: 0.9em;
    }
    pre {
      margin: 0.75em 0;
      overflow-x: auto;
      code {
        padding: 12px;
        display: block;
      }
    }
    a {
      color: ${(props) => props.theme.colors?.primary || '#2173FF'};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &.streaming-message::after {
    content: '▋';
    animation: blink 0.8s ease-in-out infinite;
    margin-left: 2px;
    color: inherit;
    opacity: 0.7;
    font-size: 0.9em;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 0.7;
    }
    50% {
      opacity: 0;
    }
  }
`;
